<template>
	<div class="milestones-container">
		<div class="milestone">
			<div class="image">
				<img v-for="(item, index) in milestoneItems" :src="imageUrl(item.image.url)" :alt="item.image.alt || ''" :class="{ active: currentItemIndex === index }" data-object-fit="cover">
			</div>
			<div class="p-8"></div>
			<div class="content">
				<div v-for="(item, index) in milestoneItems" class="text" :class="{ active: currentItemIndex === index }">
					<span class="year" v-html="item.title"></span>
					<div class="py-4"></div>
					<div class="bard sub-bard">
						<div class="bard__module text" v-html="item.text"></div>
					</div>
				</div>
				<div class="py-8 lg:py-12"></div>
				<div class="arrow-next-slide" @click="gotoNextSlide">
					<svg xmlns="http://www.w3.org/2000/svg" width="46.575" height="34.152"><path d="M0 17.254h45M28.791.707 45.16 17.076 28.791 33.445" fill="none" stroke="currentColor" stroke-width="2"/></svg>
				</div>
			</div>
		</div>
		<div class="pagination">
			<div v-for="(item, index) in milestoneItems" class="pagination-dot" :class="{ active: currentItemIndex === index }" @click="currentItemIndex = index"></div>
		</div>
	</div>
</template>

<script>
import {LoadApiData} from '../modules/api';

export default {
	name: 'milestones',
	props: {
		milestones: String,
	},
	data() {
		return {
			currentItemIndex: 0,
			milestoneItems: [],
		};
	},
	methods: {
		gotoNextSlide() {
			this.currentItemIndex = this.currentItemIndex < this.milestoneItems.length - 1 ? this.currentItemIndex + 1 : 0;
		},
		imageUrl(src) {
			return '/img' + (src || '') + '?w=1240';
		}
	},
	mounted() {
		this.milestoneItems = JSON.parse(this.milestones);
	}
};
</script>
